<template>
  <div>
    <div class="m-4">
      <p>名前から見つける</p>
      <div class="flex-row my-3">
        <input
          type="text"
          class="form-control"
          placeholder="Enter Searching Target"
          aria-label="Recipient's username"
          aria-describedby="button-addon2"
          v-model="searchTarget"
        />
        <b-button
          class="user-search-btn mx-3"
          variant="outline-secondary"
          v-on:click="searchUsersFromName"
        >
          検索
        </b-button>
      </div>

      <p>好きなジャンルから見つける</p>
      <div class="flex-row my-3">
        <b-form-select
          v-model="selected"
          :options="genreOptions"
        ></b-form-select>
        <b-button
          class="user-search-btn mx-3"
          variant="outline-secondary"
          v-on:click="searchUsersFromGenre"
        >
          検索
        </b-button>
      </div>

      <p v-if="noHit" class="my-3">該当するデータが見つかりませんでした。</p>
    </div>

    <div class="users-wrapper m-5">
      <b-list-group>
        <b-list-group-item
          class="d-flex align-items-center user-search-card"
          :href="'/user/' + user.id"
          v-for="(user, index) in users"
          :key="index"
        >
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">{{ user.name }}</span>
          <b-badge>問い投稿数：{{ user.questions.length }}</b-badge>
        </b-list-group-item>
      </b-list-group>
      <div></div>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebase";

export default {
  data() {
    return {
      users: [],
      searchTarget: "",
      selected: null,
      noHit: false,
      genreOptions: [
        { text: "-- 選択してください --", value: null },
        { text: "文学・評論", value: "文学・評論" },
        { text: "人文・思想", value: "人文・思想" },
        { text: "社会・政治", value: "社会・政治" },
        { text: "ノンフィクション", value: "ノンフィクション" },
        { text: "歴史・地理", value: "歴史・地理" },
        { text: "ビジネス・経済", value: "ビジネス・経済" },
        { text: "投資・金融・会社経営", value: "投資・金融・会社経営" },
        { text: "科学・テクノロジー", value: "科学・テクノロジー" },
        { text: "医学・薬学", value: "医学・薬学" },
        { text: "コンピュータ・IT", value: "コンピュータ・IT" },
        { text: "アート・建築・デザイン", value: "アート・建築・デザイン" },
        { text: "趣味・実用", value: "趣味・実用" },
        { text: "スポーツ・アウトドア", value: "スポーツ・アウトドア" },
        { text: "資格・検定・就職", value: "資格・検定・就職" },
        { text: "暮らし・健康・子育て", value: "暮らし・健康・子育て" },
        { text: "旅行ガイド・マップ", value: "旅行ガイド・マップ" },
        { text: "語学・辞事典・年鑑", value: "語学・辞事典・年鑑" },
        { text: "教育・学参・受験", value: "教育・学参・受験" },
        { text: "絵本・児童書", value: "絵本・児童書" },
        { text: "マンガ", value: "マンガ" },
        { text: "ライトノベル", value: "ライトノベル" },
        { text: "BL", value: "BL" },
        { text: "タレント写真集", value: "タレント写真集" },
        { text: "エンターテイメント", value: "エンターテイメント" },
        { text: "雑誌", value: "雑誌" },
        { text: "楽譜・スコア・音楽書", value: "楽譜・スコア・音楽書" },
        { text: "アダルト", value: "アダルト" }
      ]
    };
  },
  methods: {
    searchUsersFromGenre() {
      if (this.selected != null) {
        this.users = [];
        db.collection("users")
          .where("genres", "array-contains", this.selected)
          .get()
          .then(docs => {
            docs.forEach(doc => {
              const user = doc.data();
              user.id = doc.id;
              this.users.push(user);
            });
            if (this.users.length == 0) {
              this.noHit = true;
            } else {
              this.noHit = false;
            }
          });
      }
    },
    searchUsersFromName() {
      if (this.searchTarget != "") {
        this.users = [];
        db.collection("users")
          .orderBy("name")
          .startAt(this.searchTarget)
          .endAt(this.searchTarget + "\uf8ff")
          .get()
          .then(docs => {
            docs.forEach(doc => {
              const user = doc.data();
              user.id = doc.id;
              this.users.push(user);
            });
            if (this.users.length == 0) {
              this.noHit = true;
            } else {
              this.noHit = false;
            }
          });
      }
    }
  }
};
</script>

<style lang="scss">
.user-search-btn {
  width: 10%;

  @media screen and (max-width: 560px) {
    width: 28%;
    font-size: 0.7rem;
    margin: 0;
  }
}
.user-search-card:hover {
  box-shadow: 0 15px 30px -5px rgba(0, 0, 0, 0.15), 0 0 5px rgba(0, 0, 0, 0.1);
  transform: translateY(-4px);
}
.user-search-card {
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.12), 0 2px 3px 0 rgba(0, 0, 0, 0.22);
  transition: 0.3s;
}
</style>
